var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "button-background-active",
    viewBox: "0 0 280 56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H276C278.209 0 280 1.79086 280 4V52C280 54.2091 278.209 56 276 56H3.99999C1.79085 56 0 54.2091 0 52V4Z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "button-background",
    viewBox: "0 0 280 56"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4C0 1.79086 1.79086 0 4 0H276C278.209 0 280 1.79086 280 4V22L274.343 27.6569L280 33.3137V52C280 54.2091 278.209 56 276 56H3.99999C1.79085 56 0 54.2091 0 52V33.3137L5.65685 27.6569L0 22V4Z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-arrow-left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36399 18.3709C7.75452 18.7614 8.38768 18.7614 8.77821 18.3709C9.16873 17.9803 9.16873 17.3472 8.77821 16.9566L4.82157 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H4.83535L8.77821 7.05714C9.16873 6.66662 9.16873 6.03345 8.77821 5.64293C8.38768 5.25241 7.75452 5.25241 7.36399 5.64293L1.70714 11.2998C1.31661 11.6903 1.31661 12.3235 1.70714 12.714L7.36399 18.3709Z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-arrow-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2995 5.64287C15.909 5.25234 15.2758 5.25234 14.8853 5.64287C14.4947 6.03339 14.4947 6.66656 14.8853 7.05708L18.8282 11H3C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H18.8419L14.8853 16.9566C14.4947 17.3471 14.4947 17.9803 14.8853 18.3708C15.2758 18.7613 15.909 18.7613 16.2995 18.3708L21.9563 12.7139C22.3469 12.3234 22.3469 11.6902 21.9563 11.2997L16.2995 5.64287Z",
    fill: "black"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-arrow-up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.76067 7.83199C5.37014 8.22251 5.37014 8.85568 5.76067 9.2462C6.15119 9.63672 6.78436 9.63672 7.17488 9.2462L11.1178 5.30331L11.1178 21.1315C11.1178 21.6838 11.5655 22.1315 12.1178 22.1315C12.6701 22.1315 13.1178 21.6838 13.1178 21.1315L13.1178 5.28959L17.0744 9.2462C17.4649 9.63672 18.0981 9.63672 18.4886 9.2462C18.8791 8.85567 18.8791 8.22251 18.4886 7.83199L12.8317 2.17513C12.4412 1.78461 11.808 1.78461 11.4175 2.17513L5.76067 7.83199Z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-button-center",
    viewBox: "0 0 123 56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.65686 56H122.657V0H0.656864L0.65686 56Z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-button-left",
    viewBox: "0 0 14 56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0C1.79086 0 0 1.79086 0 4V22L5.65685 27.6569L0 33.3137V52C0 54.2091 1.79085 56 3.99999 56H14V0H4Z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-button-right",
    viewBox: "0 0 14 56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C12.2091 0 14 1.79086 14 4V22L8.34315 27.6569L14 33.3137V52C14 54.2091 12.2091 56 10 56H0V0H10Z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-checkbox-checked",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#BF5422"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7678 9.52255L11.1741 16.1163C10.7262 16.5642 9.98411 16.5642 9.52197 16.1163L6.23197 12.8263C5.78409 12.3784 5.78409 11.6363 6.23197 11.1741C6.67986 10.7262 7.42197 10.7262 7.88411 11.1741L10.362 13.652L16.1298 7.88413C16.5777 7.43625 17.3198 7.43625 17.782 7.88413C18.2157 8.33257 18.2157 9.07468 17.7678 9.52255H17.7678Z",
    fill: "white"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-checkbox",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 3,
    fill: "white",
    stroke: "#BF5422",
    strokeWidth: 2
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-clear",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2428 8.09131C16.4771 7.85699 16.4771 7.47709 16.2428 7.24278C16.0085 7.00846 15.6286 7.00846 15.3942 7.24278L12 10.637L8.60578 7.24275C8.37147 7.00843 7.99157 7.00843 7.75725 7.24275C7.52294 7.47706 7.52294 7.85696 7.75725 8.09127L11.1515 11.4855L7.7575 14.8795C7.52318 15.1138 7.52318 15.4937 7.7575 15.7281C7.99181 15.9624 8.37171 15.9624 8.60602 15.7281L12 12.3341L15.394 15.728C15.6283 15.9623 16.0082 15.9623 16.2425 15.728C16.4769 15.4937 16.4769 15.1138 16.2425 14.8795L12.8486 11.4855L16.2428 8.09131Z",
    fill: "#FFFDFB"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-close",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12.9497,
    y1: 3.05044,
    x2: 3.05021,
    y2: 12.9499,
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.0502,
    y1: 3.05029,
    x2: 12.9497,
    y2: 12.9498,
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-edit",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H10C10.5523 2 11 2.44772 11 3C11 3.55228 10.5523 4 10 4L4 4V16H16V10C16 9.44772 16.4477 9 17 9C17.5523 9 18 9.44772 18 10V16C18 17.1046 17.1046 18 16 18H4C2.89543 18 2 17.1046 2 16V4Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70711 10.898C7.70711 10.8715 7.71764 10.8461 7.7364 10.8273L15.8566 2.7071C16.2471 2.31658 16.8803 2.31658 17.2708 2.7071C17.6614 3.09763 17.6614 3.73079 17.2708 4.12132L9.15061 12.2415C9.13186 12.2603 9.10642 12.2708 9.0799 12.2708L7.80711 12.2708C7.75188 12.2708 7.70711 12.2261 7.70711 12.1708L7.70711 10.898Z",
    fill: "#333333"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-error",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "#D91811",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    width: 2,
    height: 8,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14,
    width: 2,
    height: 2,
    rx: 1,
    fill: "white"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-expand",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 1,
    x2: 8,
    y2: 15,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 8,
    x2: 15,
    y2: 8,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-hr-small",
    viewBox: "0 0 56 6"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7426 0L27.7426 2.99998L24.7426 6H3C1.34314 6 0 4.65685 0 3C0 1.34315 1.34315 0 3 0H24.7426ZM30.3994 6H53C54.6569 6 56 4.65685 56 3C56 1.34315 54.6569 0 53 0H30.3995L33.3995 2.99998L30.3994 6Z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-info-blue",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#1269DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 9.33337,
    width: 2.66667,
    height: 10.6667,
    rx: 1.33333,
    fill: "#FFFDFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 4,
    width: 2.66667,
    height: 2.66667,
    rx: 1.33333,
    fill: "#FFFDFB"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-info",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FFFDFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 2,
    height: 8,
    rx: 1,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#333333"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-list-item-white",
    viewBox: "0 0 9 10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 5L-4.37114e-07 10L0 -3.93402e-07L9 5Z"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-list-item",
    viewBox: "0 0 9 10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 5L-4.37114e-07 10L0 -3.93402e-07L9 5Z",
    fill: "#6D833C"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-quote",
    viewBox: "0 0 108 80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 50.4298C0 69.2264 12.6074 80 26.5903 80C39.4269 80 50.4298 69.2264 50.4298 55.9312C50.4298 43.0946 41.49 34.6132 30.4871 34.6132C27.9656 34.6132 25.6734 35.0716 24.5272 35.5301C27.5072 26.8195 38.0516 16.7335 45.3868 13.5244L28.6533 0C10.7736 12.6075 0 30.2579 0 50.4298ZM56.6189 50.4298C56.6189 69.2264 69.2264 80 83.2092 80C96.0458 80 107.049 69.2264 107.049 55.9312C107.049 43.0946 98.1089 34.6132 87.106 34.6132C84.5845 34.6132 82.2923 35.0716 81.1461 35.5301C84.1261 26.8195 94.6705 16.7335 102.006 13.5244L85.2722 0C67.3926 12.6075 56.6189 30.2579 56.6189 50.4298Z"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-radio-checked",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#BF5422"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6,
    fill: "#FFFDFB"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-radio",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "white",
    stroke: "#BF5422",
    strokeWidth: 2
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-scroll-down",
    viewBox: "0 0 47 32"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1071 14.663L23.1082 14.6641L19.5619 18.2103L21.3286 19.977L23.0964 21.7448L24.8642 19.977L41.3057 3.53553L37.7702 0L23.1071 14.663ZM18.1447 16.7931L21.6803 13.2576L8.42268 0L4.88715 3.53553L18.1447 16.7931Z",
    fill: "#FFEFD8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1074 24.7128L23.1087 24.7141L19.5622 28.2606L21.3287 30.027L23.0964 31.7948L24.8642 30.027L46.1929 8.69834L42.6574 5.16281L23.1074 24.7128ZM18.145 26.8434L21.6805 23.3078L3.53553 5.16281L0 8.69834L18.145 26.8434Z",
    fill: "#FFEFD8"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-select-down",
    viewBox: "0 0 14 9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 9L13.9282 0H0.0717969L7 9Z",
    fill: "#6D833C"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-success",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#6D833C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8.38493C18 7.62034 17.3802 7 16.6151 7C16.1817 7 15.7953 7.19948 15.5411 7.51093L15.5406 7.51041L10.5494 13.6406L8.40211 11.3152L8.40107 11.3162C8.14795 11.0423 7.787 10.8699 7.38493 10.8699C6.61982 10.8694 6 11.4891 6 12.2543C6 12.6168 6.14063 12.9454 6.36822 13.1923L6.36718 13.1933L9.59783 16.6917L9.59887 16.6907C9.85199 16.9646 10.2129 17.137 10.615 17.137C11.0483 17.137 11.4348 16.9375 11.689 16.6261L11.6895 16.6266L17.6895 9.25892L17.6889 9.2584C17.8832 9.02038 17.9999 8.71622 17.9999 8.38497L18 8.38493Z",
    fill: "white"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic-zoom-out",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5085 0.48792C16.0721 0.48792 15.7183 0.841684 15.7183 1.27807C15.7183 1.71446 16.0721 2.06823 16.5085 2.06823L20.9144 2.06823L14.581 8.40161C14.3467 8.63592 14.41 9.07914 14.7225 9.39156C15.0349 9.70398 15.4781 9.7673 15.7124 9.53298L22.0395 3.20585V7.5993C22.0395 8.03569 22.3933 8.38945 22.8297 8.38945C23.2661 8.38945 23.6199 8.03569 23.6199 7.5993V1.27807C23.6199 0.841684 23.2661 0.48792 22.8297 0.48792L16.5085 0.48792Z",
    fill: "#FFFDFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6197 16.5085C23.6197 16.0721 23.2659 15.7183 22.8295 15.7183C22.3931 15.7183 22.0393 16.0721 22.0393 16.5085L22.0393 20.9144L15.706 14.581C15.4717 14.3467 15.0284 14.41 14.716 14.7225C14.4036 15.0349 14.3403 15.4781 14.5746 15.7124L20.9017 22.0395H16.5083C16.0719 22.0395 15.7181 22.3933 15.7181 22.8297C15.7181 23.2661 16.0719 23.6199 16.5083 23.6199H22.8295C23.2659 23.6199 23.6197 23.2661 23.6197 22.8297L23.6197 16.5085Z",
    fill: "#FFFDFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.487767 7.59929C0.487767 8.03568 0.841531 8.38944 1.27792 8.38944C1.71431 8.38944 2.06807 8.03568 2.06807 7.59929L2.06807 3.19333L8.40146 9.52672C8.63577 9.76103 9.07899 9.69772 9.39141 9.3853C9.70383 9.07288 9.76714 8.62966 9.53283 8.39535L3.2057 2.06821H7.59915C8.03554 2.06821 8.3893 1.71445 8.3893 1.27806C8.3893 0.84167 8.03554 0.487907 7.59915 0.487907H1.27792C0.841531 0.487906 0.487767 0.84167 0.487768 1.27806L0.487767 7.59929Z",
    fill: "#FFFDFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59895 23.6198C8.03534 23.6198 8.38911 23.2661 8.38911 22.8297C8.38911 22.3933 8.03534 22.0395 7.59895 22.0395L3.193 22.0395L9.52638 15.7061C9.7607 15.4718 9.69738 15.0286 9.38496 14.7162C9.07254 14.4038 8.62933 14.3405 8.39501 14.5748L2.06788 20.9019V16.5085C2.06788 16.0721 1.71411 15.7183 1.27772 15.7183C0.841334 15.7183 0.487571 16.0721 0.487571 16.5085V22.8297C0.487571 23.2661 0.841334 23.6198 1.27772 23.6198L7.59895 23.6198Z",
    fill: "#FFFDFB"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "toggle-background-left",
    viewBox: "0 0 164 57"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V24.2427L0.242676 24L4.48532 28.2426L0.242675 32.4853L0 32.2426V53C0 55.2091 1.79086 57 4 57H163.5V0H4Z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "toggle-background-right",
    viewBox: "0 0 164 57"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.5 0C161.709 0 163.5 1.79086 163.5 4V24.2427L163.257 24L159.015 28.2426L163.257 32.4853L163.5 32.2426V53C163.5 55.2091 161.709 57 159.5 57H0V0H159.5Z"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "div-left",
    viewBox: "0 0 16 377"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.65686 56H122.657V0H0.656864L0.65686 56Z"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "div-center",
    viewBox: "0 0 440 377"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0C1.79086 0 0 1.79086 0 4V22L5.65685 27.6569L0 33.3137V52C0 54.2091 1.79085 56 3.99999 56H14V0H4Z"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "div-right",
    viewBox: "0 0 16 377"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C12.2091 0 14 1.79086 14 4V22L8.34315 27.6569L14 33.3137V52C14 54.2091 12.2091 56 10 56H0V0H10Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.b10c6f58118614fcf9a350036eb33923.svg";
export { ForwardRef as ReactComponent };